import { useMemo } from "react";

export const findCategoryBySlug = (categories, slug) => {
  if (!categories?.length || !slug) return undefined;
  for (const cat of categories) {
    if (cat.slug === slug) return cat;
    const found = findCategoryBySlug(cat.children, slug);
    if (found) return found;
  }
};

/** 1-based depth in the department tree (L1 department, L2 category, …). */
export const getCategoryLevel = (slug, categoriesTree) => {
  if (!slug) return 0;
  let level = 0;
  let current = findCategoryBySlug(categoriesTree, slug);
  while (current) {
    level += 1;
    current = current.parentSlug
      ? findCategoryBySlug(categoriesTree, current.parentSlug)
      : null;
  }
  return level;
};

export const useCategoryMap = (categories) => {
  return useMemo(() => {
    const map = {};

    const traverse = (nodes) => {
      nodes.forEach((n) => {
        map[n.slug] = n;
        if (n.children) traverse(n.children);
      });
    };

    traverse(categories || []);
    return map;
  }, [categories]);
};

export const buildPath = (slugs, categoryMap) => {
  const path = [];

  slugs.forEach((slug) => {
    if (!slug) return;
    const node = categoryMap[slug];
    if (node) path.push({ slug, label: node.name });
  });

  return path;
};

export const extractProductsFromTree = (node, categories = []) => {
  const newCategories = categories.concat([
    { name: node.name, isFamily: node.isFamily, slug: node.slug },
  ]);
  let prods = node.products.map((p) => ({ ...p, categories: [newCategories] }));
  if (node.children) {
    node.children.forEach((ch) => {
      prods = prods.concat(extractProductsFromTree(ch, newCategories));
    });
  }
  return prods;
};
